import React from 'react';
import PropTypes from 'prop-types';
import {
    CardContainer,
    HeaderContainer,
    ReservationsText,
    IconWrapper,
    ChartWrapper
} from './NetRevenus.styles';

import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    BarElement,
    Tooltip,
    Legend
} from 'chart.js';
import { Bar } from 'react-chartjs-2';

ChartJS.register(CategoryScale, LinearScale, BarElement, Tooltip, Legend);

const NetRevenus = ({ chartData, xAxisLabel, yAxisLabel, icon }) => {
    const isCurrency = yAxisLabel.toLowerCase().includes('revenue');
    const isMobile = typeof window !== 'undefined' && window.innerWidth <= 480;


    const data = {
        labels: chartData.labels,
        datasets: [
            {
                label: yAxisLabel,
                data: chartData.completed.map((val, i) =>
                    chartData.highlight === i ? chartData.future[i] : val
                ),
                backgroundColor: chartData.completed.map((val, i) =>
                    chartData.highlight === i ? '#61CBC9' : '#FF6600'
                ),
                borderRadius: 12,
                barThickness: isMobile ? 14 : 28,
                categoryPercentage: isMobile ? 0.5 : 0.8,
                barPercentage: isMobile ? 0.9 : 1,
            }
        ]
    };


    const options = {
        responsive: true,
        maintainAspectRatio: false,
        animation: {
            duration: 600,
            easing: 'easeOutQuart'
        },
        plugins: {
            tooltip: {
                callbacks: {
                    label: (tooltipItem) => {
                        const val = tooltipItem.raw;
                        return isCurrency
                            ? `$${val.toLocaleString()}`
                            : `${val.toLocaleString()} days`;
                    },
                },
            },
            legend: {
                display: false,
            },
        },
        scales: {
            x: {
                stacked: true,
                title: {
                    display: true,
                    text: isCurrency ? xAxisLabel : '',
                    font: {
                        size: 14,
                    },
                },
                ticks: {
                    font: {
                        size: 12,
                    },
                },
            },
            y: {
                stacked: true,
                beginAtZero: true,
                max: isCurrency ? undefined : 31,
                title: {
                    display: true,
                    text: isCurrency ? yAxisLabel : '',
                    font: {
                        size: 14,
                    },
                },
                ticks: {
                    callback: (value) =>
                        isCurrency
                            ? `$${value.toLocaleString()}`
                            : `${value.toLocaleString()} days `,
                    font: {
                        size: 12,
                    },
                },
            },
        },
    };


    return (
        <CardContainer>
            <HeaderContainer>
                <ReservationsText>{yAxisLabel}</ReservationsText>
                <IconWrapper icon={icon} />
            </HeaderContainer>
            <ChartWrapper>
                <Bar data={data} options={options} />
            </ChartWrapper>
        </CardContainer>
    );
};

NetRevenus.propTypes = {
    chartData: PropTypes.shape({
        labels: PropTypes.arrayOf(PropTypes.string).isRequired,
        completed: PropTypes.arrayOf(PropTypes.number).isRequired,
        future: PropTypes.arrayOf(PropTypes.number),
    }).isRequired,
    xAxisLabel: PropTypes.string.isRequired,
    yAxisLabel: PropTypes.string.isRequired,
    icon: PropTypes.string,
};

export default NetRevenus;
